import { useStores } from '@/hooks/use-stores';

import { DeviceType } from '@/constants/deviceTypeEnum';
import DesiccantAirDryerWidget from '@/comp/common/icons/DessicantAirDryerWidget';
import RefrigeratedAirDryerWidget from '@/comp/common/icons/RefrigeratedAirDryerWidget';

import { Entity } from '../../../NodeWidget.types';
import { areArraysEqual, buildPhysicalSchema, DEFAULT_MODEL_IDS } from '../../EditAssetDrawer.utils';

export const useInitialValues = (entity: Entity) => {
  const { devicesStore, pidEditStore } = useStores();

  const controllerId = entity.controllerId || devicesStore.getDeviceControllerId(entity.deviceId);
  const connectTo = pidEditStore.getDraftDeviceWithoutPipesByIdToDevices(entity.deviceId);
  const connectFrom = pidEditStore.getDraftDeviceWithoutPipesByIdFromDevices(entity.deviceId);
  const initialDeviceModelId = entity.deviceModelId ?? DEFAULT_MODEL_IDS[entity.deviceType];

  return {
    name: entity.name,
    deviceType: entity.deviceType,
    deviceModelId: initialDeviceModelId,
    controllerId: controllerId,
    connectTo,
    connectFrom,
  };
};

export const getDryerTypeOptions = t => [
  { value: DeviceType.DesiccantAirDryer, label: t('Desiccant Air Dryer') },
  { value: DeviceType.RefrigeratedAirDryer, label: t('Refrigerated Air Dryer') },
];

export const defaultDeviceModels = {
  [DeviceType.DesiccantAirDryer]: 'cb490cc2-c75b-41c9-8cc4-b293fb9191d6',
  [DeviceType.RefrigeratedAirDryer]: '0e47e864-5178-45d9-8322-39b45e75f961',
};

export const DRYER_WIDGET = {
  [DeviceType.DesiccantAirDryer]: DesiccantAirDryerWidget,
  [DeviceType.RefrigeratedAirDryer]: RefrigeratedAirDryerWidget,
};

export const mapFormValuesToPayload = (values, entity, initialValues) => ({
  name: values.name,
  deviceModelId: values.deviceModelId,
  deviceType: values.deviceType,
  controllerId: values.controllerId,
  ...(entity?.deviceId
    ? !areArraysEqual(initialValues.connectTo, values.connectTo) && {
        physicalSchema: buildPhysicalSchema(entity, {
          toDevices: values.connectTo,
        }),
      }
    : {
        to: values.connectTo,
        from: values.connectFrom,
      }),
});
